<template>
  <div>
    <div class="contents">
      <b-form @submit="onSubmit">
        <div class="row g-0 table-type header-col">
          <div class="col-sm-4">
            <span class="required">{{ $t("title.common.id") }}</span>
          </div>
          <div class="col-sm-8">
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                v-model="form.id"
                @keyup="availability_reset(1)"
                required
              />
              <button
                class="btn btn-primary btn-lg icon-check"
                type="button"
                @click="availability_check(1, form.id)"
              >
                {{ $t("button.common.availability_check") }}
              </button>
            </div>
          </div>

          <div class="col-sm-4">
            <span class="required">{{ $t("title.common.password") }}</span>
          </div>
          <div class="col-sm-8">
            <input type="password" v-model="form.password" required />
          </div>

          <div class="col-sm-4">
            <span class="required">
              {{ $t("title.membership.shop_name") }}
            </span>
          </div>
          <div class="col-sm-8">
            <div class="input-group">
              <input
                type="text"
                class="form-control shop-name"
                v-model="form.shopname"
                @keyup="availability_reset(2)"
                required
              />
              <button
                class="btn btn-primary btn-lg icon-check"
                type="button"
                @click="availability_check(2, form.shopname)"
              >
                {{ $t("button.common.availability_check") }}
              </button>
            </div>
          </div>

          <div class="col-sm-4">
            <span class="required">{{ $t("title.common.email") }}</span>
          </div>
          <div class="col-sm-8">
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                v-model="form.email"
                @keyup="availability_reset(3)"
                required
              />
              <button
                class="btn btn-primary btn-lg icon-check"
                type="button"
                @click="availability_check(3, form.email)"
              >
                {{ $t("button.common.availability_check") }}
              </button>
            </div>
          </div>

          <div class="col-sm-4">
            <span class="required">{{
              $t("title.membership.owner_type")
            }}</span>
          </div>
          <div class="col-sm-8 d-block">
            <div class="row row-cols-1 row-cols-sm-2 g-2">
              <div class="col">
                <select
                  class="form-select-lg"
                  v-model="form.ownertype"
                  required
                >
                  <option value="">{{ $t("filter.common.total") }}</option>
                  <option value="1">
                    {{ $t("filter.membership.franchise") }}
                  </option>
                  <option value="2">
                    {{ $t("filter.membership.direct_owned") }}
                  </option>
                </select>
              </div>
              <div class="col">
                <select
                  class="form-select-lg"
                  v-model="form.platform_type"
                  required
                >
                  <option value="0">{{ $t("text.common.online") }} {{ $t("title.common.location") }}</option>
                  <option value="1">{{ $t("text.common.offline") }} {{ $t("title.common.location") }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="col-sm-4">
            <span class="required">{{ $t("title.membership.setting") }}</span>
          </div>
          <div class="col-sm-8 d-block">
            <div class="row row-cols-1 row-cols-sm-3 g-2">
              <div class="col">
                <select
                  class="form-select-lg"
                  v-model="form.fieldunit"
                  required
                >
                  <option value="">
                    {{ $t("title.membership.fairway") }}
                  </option>
                  <option value="1">M</option>
                  <option value="2">Yard</option>
                  <option value="3">Feet</option>
                </select>
              </div>
              <div class="col">
                <select
                  class="form-select-lg"
                  v-model="form.greenunit"
                  required
                >
                  <option value="">
                    {{ $t("title.membership.green") }}
                  </option>
                  <option value="1">M</option>
                  <option value="2">Yard</option>
                  <option value="3">Feet</option>
                </select>
              </div>
              <div class="col">
                <select
                  class="form-select-lg"
                  v-model="form.speedunit"
                  required
                >
                  <option value="">
                    {{ $t("title.membership.speed") }}
                  </option>
                  <option value="1">km/h</option>
                  <option value="2">mile/h</option>
                  <option value="3">m/s</option>
                </select>
              </div>
            </div>
          </div>

          <div class="col-sm-4">
            {{ $t("title.membership.email_agree") }}
          </div>
          <div class="col-sm-8">
            <div class="form-check d-flex align-items-center py-2">
              <input
                class="form-check-input"
                type="checkbox"
                id="emailagree"
                v-model="check_form.emailagree"
              />
              <label class="form-check-label" for="emailagree">{{
                $t("text.common.agree")
              }}</label>
            </div>
          </div>

          <div class="col-sm-4">
            <span class="required">{{
              $t("title.membership.first_name")
            }}</span>
          </div>
          <div class="col-sm-8">
            <input type="text" v-model="form.firstname" required />
          </div>

          <div class="col-sm-4">
            <span class="required">{{ $t("title.membership.last_name") }}</span>
          </div>
          <div class="col-sm-8">
            <input type="text" v-model="form.lastname" required />
          </div>

          <div class="col-sm-4">
            <span class="required">{{ $t("title.common.country") }}</span>
          </div>
          <div class="col-sm-8">
            <select
              class="form-select-lg"
              v-model="form.countryno"
              required
              @change="change_country"
            >
              <option disabled>{{ $t("title.common.country") }}</option>
              <option
                :value="val.countryno"
                v-for="(val, index) in countrylist"
                :key="index + 's'"
              >
                {{ val.countryname }}
              </option>
            </select>
          </div>

          <div class="col-sm-4">
            <span class="required">{{ $t("title.membership.state") }}</span>
          </div>
          <div class="col-sm-8">
            <select
              class="form-select-lg"
              v-model="form.statesno"
              required
              @change="change_state"
            >
              <option disabled>{{ $t("title.membership.state") }}</option>
              <option
                :value="val.statesno"
                v-for="(val, index) in stateslist"
                :key="index + 's'"
              >
                {{ val.statesdesc }}
              </option>
            </select>
          </div>

          <div class="col-sm-4">
            <span class="required">{{ $t("title.membership.city") }}</span>
          </div>
          <div class="col-sm-8">
            <select
              class="form-select-lg"
              id="city"
              v-model="form.city"
              required
            >
              <option disabled>{{ $t("filter.membership.city") }}</option>
              <option
                :value="city.cityname"
                v-for="(city, index) in citylist"
                :key="index + 'c'"
              >
                {{ city.cityname }}
              </option>
            </select>
          </div>

          <div class="col-sm-4">
            <span class="required">{{ $t("title.membership.time_zone") }}</span>
          </div>
          <div class="col-sm-8">
            <select v-model="form.timezone" required class="form-select-lg">
              <option disabled>
                {{ $t("title.membership.time_zone") }}
              </option>
              <option
                v-for="(val, index) in timezonelist"
                :value="val.timezonelist_pk"
                :key="index + 't'"
              >
                {{ val.timezonelist_name }} (UTC
                {{
                  val.timezonelist_offset >= 0
                    ? "+" + val.timezonelist_offset
                    : val.timezonelist_offset
                }}:00)
              </option>
            </select>
          </div>

          <div class="col-sm-4">
            <span class="required">{{ $t("title.membership.address") }}</span>
          </div>
          <div class="col-sm-8">
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                v-model="form.address"
                @keyup="address_reset()"
                required
              />
              <button
                class="btn btn-primary btn-lg icon-check"
                type="button"
                @click="address_check(form.statesno, form.city, form.address)"
              >
                {{ $t("button.common.address_check") }}
              </button>
              <input type="hidden" v-model="form.address_lat" />
              <input type="hidden" v-model="form.address_lng" />
            </div>
          </div>
          <div class="col-sm-4">
            <span class="required">{{ $t("title.common.map") }}</span>
          </div>
          <div class="col-sm-8">
            <div class="col" style="height: 300px" id="map"></div>
          </div>
          <div class="col-sm-4">
            <span class="required">{{ $t("title.membership.post_code") }}</span>
          </div>
          <div class="col-sm-8">
            <input type="text" v-model="form.zipcode" required />
          </div>

          <div class="col-sm-4">
            <span class="required">{{ $t("title.membership.phone") }}</span>
          </div>
          <div class="col-sm-8">
            <input type="text" v-model="form.phone" required />
          </div>

          <div class="col-sm-4">
            {{ $t("title.membership.fax") }}
          </div>
          <div class="col-sm-8">
            <input type="text" v-model="form.fax" />
          </div>

          <div class="col-sm-4">
            {{ $t("title.membership.homepage") }}
          </div>
          <div class="col-sm-8">
            <input type="text" v-model="form.website" />
          </div>

          <div class="col-sm-4">
            {{ $t("title.membership.hittingbay_count") }}
          </div>
          <div class="col-sm-8">
            <select
              class="form-select-lg"
              id="roomcnt"
              v-model="form.roomcnt"
              required
            >
              <option
                :value="cnt"
                v-for="(cnt, index) in 30"
                :key="index + 'rc'"
              >
                {{ cnt }}
              </option>
            </select>
          </div>

          <div class="col-sm-4">
            {{ $t("title.membership.etc_info") }}
          </div>
          <div class="col-sm-8">
            <input type="text" v-model="form.etcinfo" />
          </div>

          <div class="col-sm-4">
            {{ $t("title.membership.locker_count") }}
          </div>
          <div class="col-sm-8">
            <select
              class="form-select-lg"
              id="lockercnt"
              v-model="form.lockercnt"
              required
            >
              <option
                :value="cnt"
                v-for="(cnt, index) in 100"
                :key="index + 'lc'"
              >
                {{ cnt }}
              </option>
            </select>
          </div>
        </div>

        <div class="btn-bottom-wrapper">
          <b-button
            size="xl"
            variant="outline-primary"
            :aria-label="$t('button.common.list')"
            @click="$router.push({ name: 'OwnerList' })"
          >
            {{ $t("button.common.list") }}
          </b-button>
          <b-button
            size="xl"
            variant="primary"
            :aria-label="$t('button.common.save')"
            type="submit"
          >
            {{ $t("button.common.save") }}
          </b-button>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import ax from "@/api/member";

export default {
  name: "OwnerWrite",
  data() {
    return {
      ownerno: this.$route.params.ownerno || false,
      form: {
        id: "",
        password: "",
        shopname: "",
        email: "",
        ownertype: "",
        platform_type: "0",
        timezone: 0,
        daylighttime: "0",
        fieldunit: "",
        greenunit: "",
        speedunit: "",
        emailagree: 0,
        firstname: "",
        lastname: "",

        city: "",
        address: "",
        zipcode: "",
        phone: "",
        fax: "",
        website: "",
        membertype: 0,
        idoverlap: 0,
        shopnameoverlap: 0,
        emailoverlap: 0,
        addressoverlap: 0,
        roomcnt: 1,
        etcinfo: "",
        lockercnt: 1,
        countryno: "0",
        statesno: "",
        address_lat: "",
        address_lng: "",
      },
      check_form: {
        daylighttime: false,
        agreeemail: true,
        id_chk: "n",
        shopname_chk: "n",
        email_chk: "n",
        address_chk: "n",
      },
      timezonelist: [],
      countrylist: [],
      stateslist: [],

      citylist: [],
      timezone_arr: [
        -11, -10, -9, -8, -7, -6, -5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8,
        9, 10, 11,
      ],
      map: null,
      mapCenter: null,
    };
  },
  methods: {
    initMap(address_lat, address_lng) {
      console.log("initMapthis.form", address_lat);
      console.log("initMapthis.form", address_lng);
      if (document.getElementById("map"))
        this.map = new google.maps.Map(document.getElementById("map"), {
          //getElementById로 map id 속성의 요소를 가져온다.
          center: {
            lat: address_lat,
            lng: address_lng,
          }, //center로 할 위도, 경도를 지정한다.
          zoom: 17, //zoom size를 지정.
          maxZoom: 20,
          minZoom: 3,
          streetViewControl: true,
          mapTypeControl: true,
          fuulscreenControl: true,
          zoomControl: true,
        });
      this.setMarker(
        {
          lat: address_lat,
          lng: address_lng,
        },
        "ce"
      );
    },
    setMarker(Points, Label) {
      //지도에 마커를 찍는 함수.
      const markers = new google.maps.Marker({
        position: Points,
        map: this.map,
        label: {
          text: Label,
          color: "#FFF",
        },
      });
    },
    get_citylist() {
      ax.get_citylist(this.form.statesno, (flag, data) => {
        if (flag) {
          this.citylist = data.citylist;
        } else {
          if (data !== "no data") alert(data);
        }
      });
    },

    availability_check(type, name) {
      if (name === "") {
        alert(
          this.$i18n.t("alert.common.field_enter", {
            field: this.$i18n.t("title.common.value"),
          })
        );

        return false;
      }
      ax.availability_check(type, name, (flag, data) => {
        if (flag) {
          alert(data.message);
        } else {
          alert(data.message);

          return false;
        }
      });
    },
    availability_reset(type) {
      if (type === 1) {
        this.check_form.id_chk = "n";
      } else if (type === 2) {
        this.check_form.shopname_chk = "n";
      } else if (type === 3) {
        this.check_form.email_chk = "n";
      }
    },
    address_reset() {
      this.check_form.address_chk = "n";
    },
    address_check(state, city, address) {
      if (address === "") {
        alert(
          this.$i18n.t("alert.common.field_enter", {
            field: this.$i18n.t("title.membership.address"),
          })
        );
        return false;
      }
      let statesname = "";
      if (this.stateslist.find((v) => v.statesno == this.form.statesno))
        statesname = this.stateslist.find(
          (v) => v.statesno == this.form.statesno
        ).statesname;
      console.log("statesname", this.stateslist);
      var addresslist = address.concat(" ", statesname, " ", city);

      ax.address_check(addresslist, (flag, data) => {
        this.initMap(
          parseFloat(data.addressinfo.lat),
          parseFloat(data.addressinfo.lng)
        );
        alert(data.message);
      });
    },

    onSubmit(event) {
      event.preventDefault();

      this.form.daylighttime =
        this.check_form.daylighttime === true ? "1" : "0";

      if (this.check_form.agreeemail) this.form.emailagree = 1;
      else this.form.emailagree = 0;

      if (this.form.id === "") {
        alert(
          this.$i18n.t("alert.common.field_enter", {
            field: this.$i18n.t("title.common.id"),
          })
        );
        return false;
      }

      if (this.form.password === "") {
        alert(
          this.$i18n.t("alert.common.field_enter", {
            field: this.$i18n.t("title.membership.password"),
          })
        );

        return false;
      }

      if (this.form.nickname === "") {
        alert(
          this.$i18n.t("alert.common.field_enter", {
            field: this.$i18n.t("title.membership.shop_name"),
          })
        );

        return false;
      }

      if (this.form.email === "") {
        alert(
          this.$i18n.t("alert.common.field_enter", {
            field: this.$i18n.t("title.membership.email"),
          })
        );

        return false;
      }

      if (this.form.firstname === "") {
        alert(
          this.$i18n.t("alert.common.field_enter", {
            field: this.$i18n.t("title.membership.first_name"),
          })
        );

        return false;
      }

      if (this.form.lastname === "") {
        alert(
          this.$i18n.t("alert.common.field_enter", {
            field: this.$i18n.t("title.membership.last_name"),
          })
        );
        return false;
      }

      if (this.form.address === "") {
        alert(
          this.$i18n.t("alert.common.field_enter", {
            field: this.$i18n.t("title.membership.address"),
          })
        );

        return false;
      }

      if (this.form.zipcode === "") {
        alert(
          this.$i18n.t("alert.common.field_enter", {
            field: this.$i18n.t("title.membership.post_code"),
          })
        );

        return false;
      }

      if (this.form.phone === "") {
        alert(
          this.$i18n.t("alert.common.field_enter", {
            field: this.$i18n.t("title.common.phone"),
          })
        );

        return false;
      }

      ax.set_adminownerregister(this.form, (flag, data) => {
        if (flag) {
          if (data.code === 200) {
            alert(data.message);
            this.$router.push({ name: "OwnerList" });
          }
        } else {
          alert(data.message);
          return false;
        }
      });
    },
    change_state() {
      this.get_citylist();
    },
    change_country() {
      this.form.statesno = "";
      this.form.city = "";
      this.form.address = "";
      this.get_stateslist();
    },
    get_countrylist() {
      ax.get_countrylist((flag, data) => {
        if (flag) {
          this.countrylist = data.countrylist;
        } else {
          alert(data);
        }
      });
    },
    get_timezonelist() {
      ax.get_timezonelist((flag, data) => {
        if (flag) {
          this.timezonelist = data.timezonelist;
        } else {
          alert(data);
        }
      });
    },
    get_stateslist() {
      ax.get_stateslist(this.form.countryno, (flag, data) => {
        if (flag) {
          this.stateslist = data.stateslist;
          console.log("states_list", this.stateslist);
        } else {
          alert(data);
        }
      });
    },
  },
  created() {
    this.get_countrylist();
    this.get_timezonelist();
  },
};
</script>
